/* Bulk order builder — /pages/bulk
   State + rendering translated from the PCO design system's BulkOrderBuilder
   template (React) to vanilla JS. Catalog (variant ids, prices) is injected by
   the section as window.PCOBulk; discounts shown here are display math only —
   the real tiered discounts are Shopify automatic discounts at checkout. */
(function () {
  var CFG = window.PCOBulk;
  var root = document.querySelector('.pco-bulk');
  if (!CFG || !root) return;

  var TIERS = [{ min: 8, pct: 0.22 }, { min: 6, pct: 0.20 }, { min: 4, pct: 0.18 }, { min: 2, pct: 0.15 }, { min: 0, pct: 0 }];
  var LADDER = [{ pct: '15%', min: 2 }, { pct: '18%', min: 4 }, { pct: '20%', min: 6 }, { pct: '22%', min: 8 }];
  var MAX_BOXES = 10, DIPS_PER_BOX = 2, LEAD_DAYS = 7, PACK_CAP = 1;
  var STEP_COUNT = 4;
  var NEXT_LABELS = { 1: 'next: add dips', 2: 'next: choose a date', 3: 'next: review order', 4: '' };

  var state = { step: 1, qty: {}, date: null };
  CFG.products.forEach(function (p) { state.qty[p.id] = 0; });
  CFG.dips.forEach(function (d) { state.qty[d.id] = 0; });
  CFG.packs.forEach(function (k) { state.qty[k.id] = 0; });

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function totalBoxes() { return CFG.products.reduce(function (s, p) { return s + state.qty[p.id]; }, 0); }
  function boxSubtotal() { return CFG.products.reduce(function (s, p) { return s + state.qty[p.id] * p.price; }, 0); }
  function indivDips() { return CFG.dips.reduce(function (s, d) { return s + state.qty[d.id]; }, 0); }
  function dipsOnly() { return CFG.dips.reduce(function (s, d) { return s + state.qty[d.id] * d.price; }, 0); }
  function packTotal() { return CFG.packs.reduce(function (s, k) { return s + state.qty[k.id] * k.price; }, 0); }
  function dipSubtotal() { return dipsOnly() + packTotal(); }
  function tierPct() {
    var b = totalBoxes();
    for (var i = 0; i < TIERS.length; i++) if (b >= TIERS[i].min) return TIERS[i].pct;
    return 0;
  }
  function discount() { return Math.round(boxSubtotal() * tierPct()); }
  function grand() { return boxSubtotal() - discount() + dipSubtotal(); }
  function boxesWord(n) { return n + ' box' + (n === 1 ? '' : 'es'); }

  /* Boxes dropping below the dip cap trims individual dips from the bottom up;
     zero boxes also clears the packs (mirrors the reference builder's clamp). */
  function clamp() {
    var boxes = totalBoxes();
    var over = indivDips() - boxes * DIPS_PER_BOX;
    for (var i = CFG.dips.length - 1; i >= 0 && over > 0; i--) {
      var id = CFG.dips[i].id;
      var take = Math.min(state.qty[id], over);
      state.qty[id] -= take; over -= take;
    }
    if (boxes === 0) CFG.packs.forEach(function (k) { state.qty[k.id] = 0; });
  }

  function setQty(kind, id, n) {
    n = Math.max(0, n);
    var boxes = totalBoxes();
    if (kind === 'box') {
      var others = boxes - state.qty[id];
      state.qty[id] = Math.min(n, MAX_BOXES - others);
      clamp();
    } else if (kind === 'dip') {
      var cap = boxes * DIPS_PER_BOX;
      var otherDips = indivDips() - state.qty[id];
      state.qty[id] = boxes === 0 ? 0 : Math.min(n, cap - otherDips);
    } else if (kind === 'pack') {
      state.qty[id] = boxes === 0 ? 0 : Math.min(n, PACK_CAP);
    }
    render();
  }

  function canAdvance() {
    if (state.step === 1) return totalBoxes() >= 1;
    if (state.step === 3) return !!state.date;
    return true;
  }
  function go(n) {
    state.step = Math.max(1, Math.min(STEP_COUNT, n));
    render();
    var target = state.step === 1 ? root : q('.bb-progress');
    var top = target.getBoundingClientRect().top + window.pageYOffset - pinOffset() - 8;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function longDate(v) {
    return new Date(v + 'T00:00:00')
      .toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })
      .toLowerCase();
  }
  function shortDate(v) {
    return new Date(v + 'T00:00:00')
      .toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
      .toLowerCase();
  }

  /* ---- dom helpers ---- */
  function q(sel) { return root.querySelector(sel); }
  function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function text(sel, v) { var el = q(sel); if (el && el.textContent !== v) el.textContent = v; }
  function show(sel, on) { var el = q(sel); if (el) el.hidden = !on; }

  /* Pinned progress sits below whatever sticky header the theme shows. */
  function pinOffset() {
    var h = document.querySelector('.shopify-section-group-header-group header, header.site-header, .site-header');
    if (!h) return 0;
    var cs = window.getComputedStyle(h);
    if (cs.position === 'sticky' || cs.position === 'fixed') return h.getBoundingClientRect().height;
    return 0;
  }

  function syncBarPad() {
    var bar = q('.bb-mobilebar');
    if (!bar) return;
    var visible = window.getComputedStyle(bar).display !== 'none';
    document.body.classList.toggle('bb-has-bar', visible);
    var h = bar.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--bb-barpad', (h ? h + 16 : 190) + 'px');
  }

  /* ---- render ---- */
  function render() {
    var boxes = totalBoxes();
    var remaining = MAX_BOXES - boxes;
    var cap = boxes * DIPS_PER_BOX;
    var have = indivDips();
    var disc = discount();
    var pct = Math.round(tierPct() * 100);

    root.setAttribute('data-pinned', state.step > 1 ? 'true' : 'false');
    root.style.setProperty('--bb-pin-top', pinOffset() + 'px');
    show('.bb-intro', state.step === 1);

    qa('.bb-step').forEach(function (el, i) {
      var n = i + 1;
      el.setAttribute('data-state', n === state.step ? 'active' : n < state.step ? 'done' : 'todo');
    });
    for (var s = 1; s <= STEP_COUNT; s++) show('[data-pane="' + s + '"]', state.step === s);

    /* step 1 rows */
    CFG.products.forEach(function (p) {
      var row = q('[data-row="' + p.id + '"]');
      if (!row) return;
      var qty = state.qty[p.id];
      row.setAttribute('data-sel', qty > 0 ? 'true' : 'false');
      row.querySelector('output').textContent = qty;
      row.querySelector('[data-bb-inc]').disabled = remaining <= 0;
      row.querySelector('[data-bb-dec]').disabled = qty <= 0;
      row.querySelector('.bb-prod__line').textContent = qty > 0 ? boxesWord(qty) + ' · ' + money(qty * p.price) : '';
    });
    text('.bb-ceiling span', boxes >= MAX_BOXES ? "you've reached the 10-box max. need more? " : 'need more than 10 boxes? ');

    /* step 2 */
    text('.bb-suggest p', boxes > 0
      ? 'based on ' + boxesWord(boxes) + ', we suggest ' + (boxes * DIPS_PER_BOX) + ' dips — two per box.'
      : "add a box first and we'll suggest an amount.");
    text('.bb-capnote', boxes > 0 ? 'individual flavors: ' + have + ' of ' + cap + ' added (max 2 per box).' : '');
    CFG.dips.forEach(function (d) {
      var row = q('[data-row="' + d.id + '"]');
      if (!row) return;
      var qty = state.qty[d.id];
      row.setAttribute('data-sel', qty > 0 ? 'true' : 'false');
      row.querySelector('output').textContent = qty;
      row.querySelector('[data-bb-inc]').disabled = boxes === 0 || have >= cap;
      row.querySelector('[data-bb-dec]').disabled = qty <= 0;
    });
    CFG.packs.forEach(function (k) {
      var row = q('[data-row="' + k.id + '"]');
      if (!row) return;
      var qty = state.qty[k.id];
      row.setAttribute('data-sel', qty > 0 ? 'true' : 'false');
      row.querySelector('output').textContent = qty;
      row.querySelector('[data-bb-inc]').disabled = boxes === 0 || qty >= PACK_CAP;
      row.querySelector('[data-bb-dec]').disabled = qty <= 0;
    });
    var parts = [];
    if (have > 0) parts.push(have + ' individual dip' + (have > 1 ? 's' : ''));
    CFG.packs.forEach(function (k) { if (state.qty[k.id] > 0) parts.push(state.qty[k.id] + ' ' + k.name); });
    text('.bb-diptally', parts.length ? 'in your order: ' + parts.join(' + ') + ' · ' + money(dipSubtotal()) : 'no dips added yet.');

    /* step 3 */
    var trigger = q('#pco-bulk-date-trigger');
    if (trigger) trigger.value = state.date ? mdY(state.date) : '';
    show('.bb-dateecho', !!state.date);
    if (state.date) q('.bb-dateecho b').textContent = longDate(state.date);

    /* step 4 */
    var orderEmpty = boxes === 0 && dipSubtotal() === 0;
    show('.bb-empty', orderEmpty);
    show('.bb-cartbody', !orderEmpty);
    text('.bb-reviewdate', state.date
      ? 'delivery targeted for ' + longDate(state.date) + ' — subject to weather & volume'
      : 'no delivery date selected.');
    renderReviewRows();
    text('[data-bb="boxsub"]', money(boxSubtotal()));
    show('[data-bb="discrow"]', disc > 0);
    text('[data-bb="discnote"]', pct + '% off · ' + boxesWord(boxes));
    text('[data-bb="discamt"]', '− ' + money(disc));
    show('[data-bb="diprow"]', dipSubtotal() > 0);
    text('[data-bb="dipsub"]', money(dipSubtotal()));
    text('[data-bb="grand"]', money(grand()));

    /* rail */
    renderRail(boxes, have, disc, pct);

    /* nav + mobile bar */
    show('.bb-back', state.step > 1);
    show('.bb-next', state.step < STEP_COUNT);
    var next = q('.bb-next');
    if (next) { next.disabled = !canAdvance(); next.querySelector('span').textContent = NEXT_LABELS[state.step] || ''; }
    var mNext = q('.bb-mnext');
    if (mNext) { mNext.hidden = state.step >= STEP_COUNT; mNext.disabled = !canAdvance(); mNext.querySelector('span').textContent = NEXT_LABELS[state.step] || ''; }
    show('.bb-mcheckout', state.step === STEP_COUNT);
    show('.bb-mback', state.step > 1);
    var bits = [];
    if (boxes > 0) bits.push(boxesWord(boxes));
    if (have > 0) bits.push(have + ' dip' + (have > 1 ? 's' : ''));
    CFG.packs.forEach(function (k) { if (state.qty[k.id] > 0) bits.push(k.name); });
    text('.bb-mobilebar__count', bits.length ? bits.join(' · ') : 'nothing added yet');
    text('.bb-mobilebar__total', money(grand()));
    show('.bb-mobilebar .bb-flash', disc > 0);
    text('.bb-mobilebar .bb-flash', "you're saving " + money(disc) + ' (' + pct + '% off boxes)');

    syncBarPad();
  }

  function renderRail(boxes, have, disc, pct) {
    var lines = [];
    CFG.products.forEach(function (p) {
      var n = state.qty[p.id];
      if (n > 0) lines.push({ label: p.name + ' · ' + boxesWord(n), amount: money(n * p.price) });
    });
    if (have > 0) lines.push({ label: 'dips ×' + have, amount: money(dipsOnly()) });
    CFG.packs.forEach(function (k) {
      var n = state.qty[k.id];
      if (n > 0) lines.push({ label: k.name + ' ×' + n, amount: money(n * k.price) });
    });
    var holder = q('.bb-rail__lines');
    holder.innerHTML = '';
    lines.forEach(function (l) {
      var div = document.createElement('div');
      div.className = 'bb-rail__line';
      var a = document.createElement('span'); a.textContent = l.label;
      var b = document.createElement('span'); b.textContent = l.amount;
      div.appendChild(a); div.appendChild(b);
      holder.appendChild(div);
    });
    show('.bb-rail__empty', lines.length === 0);

    var reached = LADDER.filter(function (r) { return boxes >= r.min; });
    var current = reached.length ? reached[reached.length - 1].min : null;
    qa('.bb-rung').forEach(function (el, i) {
      var r = LADDER[i];
      el.setAttribute('data-reached', boxes >= r.min ? 'true' : 'false');
      el.setAttribute('data-current', r.min === current ? 'true' : 'false');
    });

    var next = null;
    LADDER.forEach(function (r) { if (r.min > boxes && (!next || r.min < next.min)) next = r; });
    show('.bb-nudge', boxes >= 1 && !!next);
    if (next) {
      var need = next.min - boxes;
      text('.bb-nudge', 'add ' + need + ' more box' + (need > 1 ? 'es' : '') + ' for ' + next.pct + ' off');
    }
    show('.bb-rail .bb-flash', disc > 0);
    text('.bb-rail .bb-flash', "you're saving " + money(disc) + ' (' + pct + '% off boxes)');
    show('.bb-max', boxes >= MAX_BOXES);
    text('.bb-rail__total span:last-child', money(grand()));
  }

  function renderReviewRows() {
    var holder = q('.bb-reviewrows');
    if (!holder) return;
    holder.innerHTML = '';
    var all = [];
    CFG.products.forEach(function (p) {
      if (state.qty[p.id] > 0) all.push({ kind: 'box', item: p, sub: money(p.price) + ' / box' });
    });
    CFG.dips.forEach(function (d) {
      if (state.qty[d.id] > 0) all.push({ kind: 'dip', item: d, sub: state.qty[d.id] + ' × ' + money(d.price) });
    });
    CFG.packs.forEach(function (k) {
      if (state.qty[k.id] > 0) all.push({ kind: 'pack', item: k, sub: state.qty[k.id] + ' × ' + money(k.price) });
    });
    all.forEach(function (r) {
      var n = state.qty[r.item.id];
      var row = document.createElement('div');
      row.className = 'bb-review';
      row.innerHTML =
        '<div class="bb-review__info"><div class="bb-review__name"></div><div class="bb-review__sub"></div></div>' +
        '<div class="bb-stepper"><button type="button" data-bb-dec aria-label="Decrease quantity">−</button><output></output><button type="button" data-bb-inc aria-label="Increase quantity">+</button></div>' +
        '<div class="bb-review__amt"><strong></strong><button type="button" class="bb-iconbtn" data-bb-remove aria-label="remove">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button></div>';
      row.setAttribute('data-kind', r.kind);
      row.setAttribute('data-id', r.item.id);
      row.querySelector('.bb-review__name').textContent = r.item.name;
      row.querySelector('.bb-review__sub').textContent = r.sub;
      row.querySelector('output').textContent = n;
      row.querySelector('strong').textContent = money(n * r.item.price);
      holder.appendChild(row);
    });
  }

  function mdY(iso) {
    var p = iso.split('-');
    return p[1] + '/' + p[2] + '/' + p[0];
  }

  /* ---- date picker (reuses the theme's flatpickr delivery popup, plain
     7-day lead rule: no zip / zone logic, holidays + sundays blocked) ---- */
  var picker = null;
  var pendingDate = null;
  function initPicker() {
    var calEl = q('#pco-bulk-calendar');
    if (!calEl || typeof flatpickr === 'undefined') return;
    /* delivery-config declares the config with `let`, so it is a global lexical
       binding, not a window property — probe it with typeof. */
    var holidays = [];
    try { if (typeof deliverScheduelerConf !== 'undefined' && deliverScheduelerConf.holidays) holidays = deliverScheduelerConf.holidays; } catch (e) {}
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
    now.setDate(now.getDate() + LEAD_DAYS);
    var minStr = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
    picker = flatpickr(calEl, {
      inline: true,
      minDate: minStr,
      disable: holidays.concat([function (d) { return d.getDay() === 0; }]),
      onChange: function (dates, dateStr, inst) {
        if (dates.length > 0) {
          pendingDate = inst.formatDate(dates[0], 'Y-m-d');
          var badge = q('#pco-bulk-earliest');
          if (badge) badge.textContent = shortDate(pendingDate);
        } else {
          pendingDate = null;
        }
      },
      onReady: function (dates, dateStr, inst) {
        var first = inst.days && inst.days.querySelector('.flatpickr-day:not(.flatpickr-disabled)');
        if (first) first.click();
      }
    });
  }
  function openDateModal() {
    var m = q('#pco-bulk-modal');
    m.classList.add('is-active');
    if (picker) picker.redraw();
    window.setTimeout(function () {
      if (!pendingDate) {
        var first = m.querySelector('.flatpickr-day:not(.flatpickr-disabled)');
        if (first) first.click();
      }
    }, 50);
  }
  function closeDateModal() { q('#pco-bulk-modal').classList.remove('is-active'); }

  /* ---- checkout ---- */
  var checkingOut = false;
  function checkout() {
    if (checkingOut) return;
    var items = [];
    var dateLabel = state.date ? mdY(state.date) : '';
    function pushItems(list) {
      list.forEach(function (x) {
        var n = state.qty[x.id];
        if (n > 0) items.push({ id: x.variantId, quantity: n, properties: { 'Delivery date': dateLabel } });
      });
    }
    pushItems(CFG.products); pushItems(CFG.dips); pushItems(CFG.packs);
    if (!items.length || !state.date) return;
    checkingOut = true;
    var btns = qa('[data-bb-checkout]');
    btns.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = 'adding to cart…'; });
    var rootUrl = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'could not add to cart'); });
      return fetch(rootUrl + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Delivery date': dateLabel, 'Bulk order': 'yes' } })
      });
    }).then(function () {
      window.location.href = rootUrl + 'checkout';
    }).catch(function (err) {
      checkingOut = false;
      btns.forEach(function (b) { b.disabled = false; b.querySelector('span').textContent = 'proceed to checkout'; });
      var box = q('.bb-carterr');
      box.hidden = false;
      box.textContent = 'something went wrong adding your order to the cart — ' + String(err.message || err).toLowerCase() + '. please try again or email csteam@thepretzelcompany.com.';
    });
  }

  /* ---- events (delegated) ---- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var stepBtn = t.closest('[data-bb-inc], [data-bb-dec]');
    if (stepBtn) {
      var row = stepBtn.closest('[data-kind]');
      if (row) {
        var id = row.getAttribute('data-id');
        var delta = stepBtn.hasAttribute('data-bb-inc') ? 1 : -1;
        setQty(row.getAttribute('data-kind'), id, state.qty[id] + delta);
      }
      return;
    }
    var rm = t.closest('[data-bb-remove]');
    if (rm) {
      var rrow = rm.closest('[data-kind]');
      if (rrow) setQty(rrow.getAttribute('data-kind'), rrow.getAttribute('data-id'), 0);
      return;
    }
    if (t.closest('[data-bb-next]')) { if (canAdvance()) go(state.step + 1); return; }
    if (t.closest('[data-bb-back]')) { go(state.step - 1); return; }
    if (t.closest('[data-bb-checkout]')) { checkout(); return; }
    var nutri = t.closest('[data-bb-nutri]');
    if (nutri) { openNutri(nutri.getAttribute('data-bb-nutri')); return; }
    if (t.closest('[data-bb-modal-close]')) { closeNutri(); return; }
    var acc = t.closest('.bb-acc__q');
    if (acc) {
      var item = acc.closest('.bb-acc__item');
      item.setAttribute('data-open', item.getAttribute('data-open') === 'true' ? 'false' : 'true');
      return;
    }
    if (t.closest('#pco-bulk-date-trigger')) { e.stopPropagation(); openDateModal(); return; }
    if (t.closest('#pco-bulk-confirm')) {
      e.stopPropagation();
      if (pendingDate) { state.date = pendingDate; render(); }
      closeDateModal();
      return;
    }
    if (t.closest('#pco-bulk-modal')) { e.stopPropagation(); return; }
  });
  document.addEventListener('click', function () {
    var m = q('#pco-bulk-modal');
    if (m && m.classList.contains('is-active')) closeDateModal();
  });
  var modal = q('.bb-modal');
  if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeNutri(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeNutri(); closeDateModal(); }
  });

  /* ---- nutrition modal ---- */
  function openNutri(id) {
    var p = null;
    CFG.products.forEach(function (x) { if (x.id === id) p = x; });
    if (!p) return;
    var m = q('.bb-modal');
    m.hidden = false;
    m.querySelector('h3').textContent = p.name;
    qa('.bb-nutripanel img').forEach(function (img) {
      img.setAttribute('data-show', img.getAttribute('data-nutri') === id ? 'true' : 'false');
    });
    document.body.style.overflow = 'hidden';
  }
  function closeNutri() {
    var m = q('.bb-modal');
    if (m && !m.hidden) { m.hidden = true; document.body.style.overflow = ''; }
  }

  window.addEventListener('resize', function () {
    syncBarPad();
    root.style.setProperty('--bb-pin-top', pinOffset() + 'px');
  });

  function boot() {
    initPicker();
    render();
  }
  if (typeof flatpickr === 'undefined') {
    window.addEventListener('load', boot);
  } else {
    boot();
  }
})();
